import {
	createReducer,
	createSlice,
	createAction,
	createAsyncThunk,
	createEntityAdapter,
} from '@reduxjs/toolkit';

import { API } from '../../api';

export const doClose = createAsyncThunk(
	"response/doClose",
	async (data, thunkAPI)  => {
		let payload = {
			text: data.text,
			requestKey: data.requestKey
		};
		return API.doClose(payload);
	}
);


export const doRecall = createAsyncThunk(
	"response/doRecall",
	async (data, thunkAPI)  => {
		return API.doRecall({ requestKey: data.requestKey });
	}
);

export const doQuestion = createAsyncThunk(
	"response/doQuestion",
	async (data, thunkAPI)  => {
		let payload = {
			text: data.text,
			requestKey: data.requestKey
		};
		return API.doQuestion(payload);
	}
);



export const clearCache = createAsyncThunk(
	"response/clearCache",
	async (cacheKey, thunkAPI)  => {
		console.log("clearing chache via dispatch!!");
		return API.cache.delete(cacheKey);
	}
);



// Then, handle actions in your reducers:
const responseSlice = createSlice({
	name: "response",
	initialState: { responses: {} },
	reducers: {
		clearCache: (state, action) => {
			console.log("clear cache action: %o", action);
			API.cache.delete(action.payload);
		}
	},
	extraReducers: {
		// [doClose.pending]: (state, action) => {
		// 	state.claiming = true;
		// },
		// [apiDoClaim.fulfilled]: (state, action) => {
		// 	state.claiming = false;
		// },
		[doQuestion.fulfilled]: (state, action) => {
			console.log("fulfilled: %o", action);
		},
		[doQuestion.rejected]: (state, action) => {
			console.log("rejected: %o", action);
		}		
		
	}

});


export default responseSlice.reducer; 
